import { Component, inject, Input } from '@angular/core';
import { FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { PasswordModule } from 'primeng/password';
import { FluidModule } from 'primeng/fluid';
import { AuthStore } from '@navstation-portal/shared/data-access/auth';
import { IconComponent } from '@navstation-portal/shared/ui/components';
import { IconNames } from '@navstation-portal/shared/data-model/ui';

const LOGIN_IMPORTS = [
  InputTextModule,
  FormsModule,
  ButtonModule,
  CheckboxModule,
  PasswordModule,
  FluidModule,
  ReactiveFormsModule,
] as const;

@Component({
  selector: 're-login-content',
  templateUrl: './login-content.component.html',
  styleUrl: './login-content.component.css',
  imports: [...LOGIN_IMPORTS, IconComponent],
})
export class LoginContentComponent {
  IconNames = IconNames;

  @Input() onLoginSubmit!: (a: string, b: string) => void;
  @Input() message!: string;
  @Input() qaBuild = false;

  authStore = inject(AuthStore);
  formBuilder = inject(FormBuilder);

  loginForm = this.formBuilder.group({
    username: [''],
    password: [''],
    keepLoggedIn: [false],
  });

  onLogin = () => {
    const { username, password } = this.loginForm.value;
    if (typeof username !== 'string' || typeof password !== 'string') return;

    this.onLoginSubmit(username, password);
  };
}
